export function searchString(value: unknown): string | undefined {
    return typeof value === 'string' && value.length > 0 ? value : undefined
}

export function searchEnum<T extends string>(
    value: unknown,
    allowed: ReadonlyArray<T>,
): T | undefined {
    const s = searchString(value)
    return s !== undefined && (allowed as ReadonlyArray<string>).includes(s) ? (s as T) : undefined
}
